/* GeneratedContentHash: 8cdc16d09a6f36b8c67b38669698ce0096286cf32ed5f7ae71b6d997f6182e38 */
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from 'react';

export default {
	'test-message-inapp': lazy(
		() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--test-message-inapp/placements/in-app/confluence-home-banner/render'
			),
	),
};
